import { DiagnosticLogInfoData } from "../types/DiagnosticsData";

export interface DiagnosticsState {
    // session
    sessionId?: string;
    duration?: number;
    diagnosticsData: DiagnosticLogInfoData;
}

export const initialState: DiagnosticsState = {
    diagnosticsData: {
        diagnosticsLogNodes: [],
        livestreamStartupFlowSteps: [],
    },
};
